import { arrayOf, bool, number, objectOf, shape, string } from 'prop-types';

import { basicProductShape } from '../../prop-types';

export const UPLOAD = 'Upload';

export const WRITABLE_BUDGET_FIELDS = [
  'netClientBudgetExternal',
  'wkzBudget',
  'freeService',
  'coInvest',
];

export const BUDGET_FIELDS = [
  'budget',
  'netClientBudget',
  'freeService',
  'coInvest',
];

export const BUDGET_FIELDS_LABELS = {
  budget: 'Budget',
  netClientBudgetExternal: 'Net Client Budget External',
  wkzBudget: 'Net Client Budget WKZ',
  freeService: 'Free Service',
  coInvest: 'Co Invest',
};

const budgetFieldsShape = shape({
  netClientBudgetExternal: number.isRequired,
  wkzBudget: number.isRequired,
  coInvest: number.isRequired,
  freeService: number.isRequired,
});

export const productAggregatesMapShape = objectOf(
  shape({
    label: string.isRequired,
    product: basicProductShape.isRequired,
    adjustedFee: number.isRequired,
    oldValues: budgetFieldsShape.isRequired,
    newValues: budgetFieldsShape.isRequired,
  }).isRequired,
);

export const cPBAdditionalParamsShape = shape({
  attachmentIds: arrayOf(number),
  primaryContactId: number,
  secondaryContactId: number,
  ccSecondaryContact: bool,
  signerSecondaryContact: bool,
});
